import { LineBasicMaterial } from "three";
import { Shaders } from "../shaders";
import { mySetValuesImpl } from "./index";
export class PickingLineBasicMaterial extends LineBasicMaterial {
    constructor(parameters) {
        var _a, _b, _c;
        super(parameters);
        this.objectId = (_a = parameters === null || parameters === void 0 ? void 0 : parameters.objectId) !== null && _a !== void 0 ? _a : 0;
        this.extraId = (_b = parameters === null || parameters === void 0 ? void 0 : parameters.extraId) !== null && _b !== void 0 ? _b : 0;
        this.userIdChannel = (_c = parameters === null || parameters === void 0 ? void 0 : parameters.userIdChannel) !== null && _c !== void 0 ? _c : false;
    }
    setValues(parameters) {
        return mySetValuesImpl(this, parameters);
    }
    copy(material) {
        super.copy(material);
        if (material instanceof PickingLineBasicMaterial) {
            this.objectId = material.objectId;
            this.extraId = material.extraId;
        }
        return this;
    }
    onBeforeCompile(shader, renderer) {
        super.onBeforeCompile(shader, renderer);
        shader.vertexShader = Shaders.meshBasic.vertex(this.userIdChannel);
        shader.fragmentShader = Shaders.meshBasic.fragment(this.userIdChannel);
        shader.uniforms.objectId = {
            value: this.objectId,
        };
        shader.uniforms.extraId = {
            value: this.extraId,
        };
    }
    customProgramCacheKey() {
        return `:
        ${this.version}
        ${this.userIdChannel}
        `;
    }
}
